import { DateTime } from 'luxon'

export default definePayloadPlugin(() => {
  definePayloadReducer('DateTime', (data) => data instanceof DateTime && data.toISO())
  definePayloadReviver('DateTime', (data: string) => DateTime.fromISO(data))
})
